var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-column accordion",class:_vm.accordionClasses},[_c('h5',{staticClass:"footer--header accordion-header",on:{"click":_vm.toggleAccordion}},[_vm._v(" "+_vm._s(_vm.heading)+" ")]),_c('div',{staticClass:"footer--content accordion-body",style:(_vm.accordionBody)},[_c('div',{ref:"accordionBodyRef"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }